module.exports = __webpack_public_path__ + "media/images/new/icons/app_apple-13230b45659c6490e8fb89ca50a0a01b.png";